import "./ServiceCss.css"

export const TTAAssistModel = () => {
  return (
    <div className="section">
      <div className="content">
        <div className="assist">
          <div className="border">
            <h2 className="assist_h">TTA-Assist Service Model</h2>
            <p className="assist_p">
              To help fleet owners keep their trucks running whatever their
              budget, we offer two types of service plan. These are
            </p>
          </div>
        </div>
        <div className="imagebox">
          <p className="imagebox-p">
            TTA – Protect: The protection plan allows truck owners to pay a
            fixed monthly fee (paid annually) per truck and enjoy unlimited
            services covered by TTA-Assist (Terms & Conditions Apply).
          </p>
          <p className="imagebox-p2">
            TTA – Per Use: Pay per use allows a truck owner to pay per truck for
            any of the services covered by TTA – Assist.
          </p>
        </div>
      </div>
    </div>
  );
}
